<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <div class="wtitle">盈利余额：{{ income }}</div>
      <el-table
        :data="tableData"
        highlight-current-row
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column property="order" label="订单号"></el-table-column>
        <el-table-column property="time" label="日期"></el-table-column>
        <el-table-column property="type" label="类型"></el-table-column>
        <el-table-column property="remark" label="备注"></el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">
            <a style="color: green" v-if="scope.row.add"
              >+{{ scope.row.price }}</a
            >
            <a style="color: red" v-else>-{{ scope.row.price }}</a>
          </template>
        </el-table-column>
        <el-table-column property="sum" label="账户余额"></el-table-column>
      </el-table>

      <div class="Pagination" style="text-align: left; margin-top: 10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="index"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="count"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="余额提现" :visible.sync="dialogVisible" width="40%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="支付宝账号：" style="clear: both">
          <el-input style="width: 80%" size="small" v-model="huming"></el-input>
        </el-form-item>
        <el-form-item label="收款方姓名：" style="clear: both">
          <el-input
            style="width: 80%"
            size="small"
            v-model="zhanghu"
          ></el-input>
        </el-form-item>
        <el-form-item label="提现金额：" style="clear: both">
          <el-input style="width: 80%" size="small" v-model="price"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import myAxios from "../myAxios";
export default {
  data() {
    return {
      dialogVisible: false,
      huming: "",
      zhanghu: "",
      price: "",
      username: localStorage.getItem("username"),
      url: localStorage.getItem("url"),
      tableData: [], //用户列表数据
      index: 1, //页码
      size: 20, //页大小
      count: 0, //数据总数
      loading: false, //加载状态
      income: 12,
    };
  },
  components: {
    HeadTop,
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      try {
        this.getMedia();
      } catch (err) {
        console.log("获取数据失败", err);
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(val);
      this.index = val;
      this.getMedia();
    },
    async getMedia() {
      myAxios
        .get(
          `/client_media/Incomes/v1?username=${this.username}&index=${this.index}&size=${this.size}`
        )
        .then((res) => {
          this.tableData = res.data.balance_histories;
          this.income = res.data.income;
          this.count = res.total;
        });
      this.loading = false;
    },
    sure() {
      myAxios
        .post(
          `/client_media/Encash/v1?username=${this.username}&price=${this.price}&payeeAccount=${this.huming}&payeeRealName=${this.zhanghu}`
        )
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: res.data,
            });
            this.getMedia();
          } else {
            this.$message({
              type: "success",
              message: res.message,
            });
          }
        });
    },
  },
};
</script>

<style lang="less">
@import "../style/mixin";
.table_container {
  padding: 20px;
}
.wtitle {
  text-align: center;
  height: 60px;
  line-height: 60px;
  font-size: 20pt;
}
</style>
